@if (user.watch | async; as _user) {
<!-- Toggle button for collapsed sidebar -->
@if (_user.loggedIn && collapsed) {
<button class="sidebar-toggle" (click)="toggleCollapse()">
    <span class="toggle-icon">☰</span>
</button>
} @if (_user.loggedIn) {
<aside class="app-sidebar" [class.collapsed]="collapsed">
    <!-- Collapse button inside sidebar -->
    <button class="sidebar-collapse-btn" (click)="toggleCollapse()">
        <span class="collapse-icon">✕</span>
    </button>
    <!-- Navigation -->
    <nav class="sidebar-nav">
        <ul class="nav-list">
            @for (item of nav; track item) { @if (!item.roles || user.isGranted(item.roles)) {
            <li class="nav-item">
                <!-- Item with children (expandable) -->
                @if (item.children?.length) {
                <div class="nav-link has-children" [class.expanded]="isExpanded(item.label)">
                    <a
                        class="nav-link-content"
                        [routerLink]="item.route"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: item.matchExact || false}"
                        (click)="expandItem(item.label)"
                    >
                        <span class="nav-icon">
                            <img [src]="item.svgIcon" [alt]="item.label" />
                        </span>
                        <span class="nav-text">{{ item.label }}</span>
                    </a>
                    <span class="expand-icon" (click)="toggleExpanded(item.label)">
                        <i class="fa" [class.fa-angle-up]="isExpanded(item.label)" [class.fa-angle-down]="!isExpanded(item.label)"></i>
                    </span>
                </div>
                @if (isExpanded(item.label)) {
                <ul class="nav-children">
                    @for (child of item.children; track child) { @if (!child.roles || user.isGranted(child.roles)) {
                    <li [class.has-grandchildren]="child.children?.length">
                        <!-- Child with grandchildren -->
                        @if (child.children?.length) {
                        <a class="nav-child-link has-children" [class.expanded]="isExpanded(child.label)" (click)="toggleExpanded(child.label)">
                            {{ child.label }}
                            <span class="expand-icon">
                                <i class="fa" [class.fa-angle-up]="isExpanded(child.label)" [class.fa-angle-down]="!isExpanded(child.label)"></i>
                            </span>
                        </a>
                        @if (isExpanded(child.label)) {
                        <ul class="nav-grandchildren">
                            @for (grandchild of child.children; track grandchild) { @if (!grandchild.roles || user.isGranted(grandchild.roles)) {
                            <li>
                                <a
                                    class="nav-grandchild-link"
                                    [routerLink]="grandchild.route"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}"
                                >
                                    {{ grandchild.label }}
                                </a>
                            </li>
                            } }
                        </ul>
                        } }
                        <!-- Child without grandchildren -->
                        @if (!child.children?.length) {
                        <a class="nav-child-link" [routerLink]="child.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                            {{ child.label }}
                        </a>
                        }
                    </li>
                    } }
                </ul>
                } }
                <!-- Item without children -->
                @if (!item.children?.length) {
                <a
                    class="nav-link"
                    [class.nav-dashboard]="item.label === 'Dashboard'"
                    [class.nav-clients]="item.label === 'Clients'"
                    [class.nav-finance]="item.label === 'Finance & Sustainability'"
                    [routerLink]="item.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: item.matchExact || false}"
                >
                    <span class="nav-icon">
                        <img [src]="item.svgIcon" [alt]="item.label" />
                    </span>
                    <span class="nav-text">{{ item.label }}</span>
                </a>
                }
            </li>
            } }
        </ul>
    </nav>
</aside>
} }
